import i18n from '@/i18n';
import { userLocal } from '@/utils/ipeUserLocalState';

export const SOURCING_WORKFLOW_HISTORY_KEY = 'ipe-sourcing-workflow-last-run-v1';

export function buildQuickLinksFromPipelineResult(result) {
  const links = [];
  const steps = result?.steps || [];
  const seen = new Set();
  const add = (label, path, dedupeKey) => {
    if (!path || seen.has(dedupeKey)) return;
    seen.add(dedupeKey);
    links.push({ label, path });
  };

  for (const s of steps) {
    switch (s.navId) {
      case 'imageCrop':
        if (s.taskId)
          add('裁剪', `/ipe/image-crop-detail/${encodeURIComponent(s.taskId)}`, `crop-${s.taskId}`);
        break;
      case 'smartCutout':
        if (s.taskId)
          add('抠图', `/ipe/ai-image-detail/smartCutout/${encodeURIComponent(s.taskId)}`, `cut-${s.taskId}`);
        break;
      case 'imageEnhance':
        if (s.taskId)
          add('放大', `/ipe/ai-image-detail/imageEnhance/${encodeURIComponent(s.taskId)}`, `enh-${s.taskId}`);
        break;
      case 'stampExtract':
        if (s.taskId)
          add(
            '印花',
            '/ipe/stamp-extract',
            `stamp-${s.taskId}`,
          );
        break;
      case 'goods':
        if (s.goodsTaskId)
          add('套图', `/ipe/goods-detail/${encodeURIComponent(s.goodsTaskId)}`, `goods-${s.goodsTaskId}`);
        break;
      case 'titles':
        // 标题提取已下线；历史任务入口改为 AI文案工作台
        add('AI文案', '/ipe?activeNav=aiCopywriting', 'aiCopywriting');
        break;
      default:
        break;
    }
  }
  return links;
}

export function summarizePipelineHistory(result, templateName) {
  const name = templateName || '工作流';
  if (!result) return i18n.t('workbench:ipeUtilError.stepNotRun', { name });
  if (!result.ok) {
    const err = String(result.error || '失败').trim();
    const short = err.length > 40 ? `${err.slice(0, 40)}…` : err;
    return i18n.t('workbench:ipeUtilError.stepFailedShort', { name, detail: short });
  }
  const steps = result.steps || [];
  const skipped = steps.filter((s) => s.status === 'skipped').length;
  const taskCreated = steps.filter((s) => s.status === 'task_created').length;
  const parts = [`${name} · 完成`];
  if (skipped) parts.push(`${skipped} 步跳过`);
  if (taskCreated) parts.push('含仅建任务');
  return parts.join(' · ');
}

export function persistSourcingWorkflowRuns(template, results) {
  if (!Array.isArray(results)) return;
  const name = template?.name || '';
  try {
    const map = userLocal.getJson(SOURCING_WORKFLOW_HISTORY_KEY, {}) || {};
    const next = typeof map === 'object' && map && !Array.isArray(map) ? { ...map } : {};
    results.forEach(({ row, result }) => {
      const id = row?.id;
      if (id == null || id === '') return;
      const links = buildQuickLinksFromPipelineResult(result);
      next[String(id)] = {
        updatedAt: new Date().toISOString(),
        ok: !!result?.ok,
        error: result?.error || null,
        templateName: name,
        templateId: template?.id || '',
        summaryLine: summarizePipelineHistory(result, name),
        links,
      };
    });
    userLocal.setJson(SOURCING_WORKFLOW_HISTORY_KEY, next);
  } catch (e) {
    console.warn('[sourcing] persist workflow history failed', e);
  }
  try {
    window.dispatchEvent(new CustomEvent('ipe-sourcing-workflow-history-updated'));
  } catch {
    /* ignore */
  }
}

export function loadSourcingWorkflowHistoryRow(itemId) {
  if (itemId == null || itemId === '') return null;
  try {
    const map = userLocal.getJson(SOURCING_WORKFLOW_HISTORY_KEY, {}) || {};
    return map[String(itemId)] || null;
  } catch {
    return null;
  }
}

export function clearSourcingWorkflowRunHistoryForLogout() {
  userLocal.dropLegacyKeys(SOURCING_WORKFLOW_HISTORY_KEY);
}

export function formatWorkflowHistoryTime(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return `${d.getMonth() + 1}/${d.getDate()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  } catch {
    return '';
  }
}
